import FormBaseModel from '@cp-models/FormBaseModel';
import ContractPlan from '@cp-models-common/ContractPlan'
import PlanModule from '@cp-models-common/PlanModule'

export default class Plan extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'internal_id': 'number',
            'company_id': 'number',
            'id_company': 'number',
            'plan_id': 'number',
            'vindi_plan_id': 'number',
            'subscription_id': 'number',
            'vindi_subscription_id': 'number',
            'payment_method': 'string',
            'selected_at': 'any',
            'canceled': 'boolean',
            'cancelation_reason': 'string',
            'changed': 'boolean',
            'changed_at': 'any',
            'consultant': 'string',
            'consultant_id': 'number',
            'new_plan_id': 'number',
            'final_price': 'number',
            'regular_price': 'number',
            'name': 'string',
            'type': 'string',
            'representative_name': 'string',
            'representative_cpf': 'string',
            'representative_rg': 'string',
            'modules': [PlanModule],
            'discount_due_at': 'any',
            'created_at': 'any',
            'updated_at': 'any',
            'disabled': 'boolean',
            'contract_plan': ContractPlan
        }
    }

    get companyId()
    {
        return this.company_id ? this.company_id : this.id_company
    }

    get subscriptionId()
    {
        return this.subscription_id ? this.subscription_id : this.vindi_subscription_id
    }

    get selectedAt()
    {
        return this.selected_at ? this.formatDate(this.selected_at.substring(0, 19)) : ''
    }

    get changedAt()
    {
        return this.formatDate(this.changed_at)
    }
    get createdAt()
    {
        return this.formatDate(this.created_at)
    }

    get updatedAt()
    {
        return this.formatDate(this.updated_at)
    }

    get discountDueAt()
    {
        return this.discount_due_at
            ? new Intl.DateTimeFormat('pt-BR', {
                year: 'numeric', month: '2-digit', day: '2-digit',
            }).format(new Date(this.discount_due_at+'T00:00:00'))
            : '';
    }

    get deletedAt()
    {
        return this.disabled
            ? this.formatDate(this.updated_at)
            : null
    }

    get regularPriceBr()
    {
        return this.formatCurrency(this.regular_price)
    }

    get finalPriceBr()
    {
        return this.formatCurrency(this.final_price)
    }

    get moduleBase()
    {
        return _.filter(this.modules, (module) => {
            return module.type == 'base_price'
        })[0]
    }
}